
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { applyPlatformClasses } from './utils/platformUtils'; // Add this import

// Import Capacitor core to ensure window.Capacitor is available for platform detection
import '@capacitor/core';

// Import IndexedDB clear utility for development
import './utils/clearIndexedDB';

// Initialize the app when DOM is ready
const initializeApp = () => {
  try {
    const rootElement = document.getElementById('root');
    
    if (!rootElement) {
      console.error('Root element not found in the DOM!');
      return;
    }

    // Apply platform classes BEFORE React renders
    applyPlatformClasses();

    // Only initialize if root element is empty
    if (rootElement.hasChildNodes()) {
      return;
    }

    const root = createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Fatal error during app initialization:', error);
  }
};

// Wait for DOM to be ready
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initializeApp();
} else {
  document.addEventListener('DOMContentLoaded', initializeApp);
}
